import React from 'react';
import { Variable } from 'src/api/types';
import { Poppins } from 'src/common';
import styled from 'styled-components';
import { WizardIcon } from 'src/components/FormulaInput/comps/WizardIcon';

const Capsule = styled.div`
  background-color: ${({ theme }) => theme.colors.aliceBlue};
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  padding: 2px 10px;
  display: inline-flex;
  align-items: center;
  grid-gap: 6px;
`;

const normalize = (text?: string | number | null) => text?.toString().replace(/[\s_]/g, '').toLowerCase();

interface VariableCapsuleProps {
  id: string;
  variables: Variable[];
}
export const VariableCapsule: React.FC<VariableCapsuleProps> = ({ id, variables }) => {
  const target = normalize(id);
  const variable = variables.find(
    (v) => normalize(v.id) === target || normalize(v.alias) === target || normalize(v.name) === target,
  );
  const label = variable?.alias || variable?.name || variable?.id?.toString() || '';
  return label ? (
    <Capsule>
      {(variable?.workspace_variable || (variable as any)?.isGlobal) && (
        <span className="wizard-icon">
          <WizardIcon />
        </span>
      )}
      <Poppins px={14} weight={500}>
        {label}
      </Poppins>
    </Capsule>
  ) : null;
};
